// extracted by mini-css-extract-plugin
export default {"input":"AddCategoryModal_input__7K6Ci","placeHolderShimmer":"AddCategoryModal_placeHolderShimmer__9w6N4"};